<h2 mat-dialog-title class="mat-dialog-title-offset">Upload learner</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
    <div class="close-modal modal-close-icon">
    </div>
  </button>
</div>

<mat-dialog-content class="mat-typography modal-master-container tw:mx-2">
  <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-2 content-container">

    <div class="tw:flex tw:flex-wrap tw:px-0 tw:pb-6 tw:mx-0 tw:my-2">

      <div class="tw:w-full tw:px-[15px]">
        <div class="file-selector-container">
          <div>
            <mat-toolbar>
              <input [(ngModel)]="fileAttr" readonly name="name" class="field__control file-select-text" />

              <button mat-flat-button class="btn btn-primary" style="z-index: 10;"
                (click)="fileInput.click()">
                Browse File
              </button>

            </mat-toolbar>

            <input type="file" #fileInput id="uploadFile" (change)="uploadFileEvt($event)" name="uploadFile"
              multiple="false" accept=".csv" />
            </div>
          </div>
          @if (showInvalidFileTypeError) {
            <div class="tw:text-danger tw:mb-2">Please upload only .CSV files</div>
          }
          @if (showInvalidFileError) {
            <div class="tw:text-danger tw:mb-2">The file is invalid, please try another.</div>
          }
        </div>

        <div class="tw:w-full tw:px-[15px] tw:mb-6">
          <label class="drop-down-label">Client</label>
          <app-searchable-select [(ngModel)]="uploadSelectedClientId" [items]="clientList"
            displayField="clientName" valueField="clientId" placeholder="Select a client"
            searchPlaceholder="Search clients…"></app-searchable-select>
          @if (showClientAccessError) {
            <div class="tw:text-danger">No Valid Client Roles Assigned.</div>
          }
        </div>

        @if (themeService.siteContent.enableStudentEmailing == 'true' && hasEmailStudentAccessLinkPermission) {
          <div class="tw:w-full tw:px-[15px] tw:pt-6" style="border-top: solid 1px grey;"
            >
            <div class="form-group tw:mb-0">
              <label class="field__toggle">
                <input type="checkbox" name="createLoginsSlider" [(ngModel)]="createLogins" />
                <span class="field__toggle-track"></span>
                Auto send learners without logins a new login
                email
              </label>
            </div>
          </div>
        }

        @if (uploadResponseMessages.length > 0 || uploadResponseMainMessage != '') {
          <div id="responseMessageContainer" class="tw:w-full tw:px-[15px] tw:mt-6">
            <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
              <div class="tw:flex-1 tw:p-0 tw:m-0 tw:flex tw:justify-start">
                @if (warningMessage) {
                  <i class="las la-info-circle la-3x tw:text-warning" style="transform: rotate(180deg);"></i>
                }
                @if (errorMessage) {
                  <i class="las la-exclamation-triangle la-3x tw:text-danger"></i>
                }
                <label class="tw:my-auto tw:ml-3" [ngClass]="{'tw:text-danger': errorMessage, 'tw:text-warning': warningMessage}">
                  {{uploadResponseMainMessage}}
                </label>
              </div>
            </div>
            <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
              <div class="tw:flex-1 tw:p-0 tw:m-0">
                <ul>
                  @for (message of uploadResponseMessages; track message) {
                    <li>{{message}}</li>
                  }
                </ul>
              </div>
            </div>
          </div>
        }

      </div>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="div-flex-buttons">
    <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:w-full">
      <div class="tw:w-full tw:p-0 tw:m-0">

        <button mat-button [mat-dialog-close]="false" class="btn btn-primary tw:mx-1">Close</button>

        <button type="button" class="btn btn-primary tw:mx-1 tw:float-right" (click)="uploadStudent()"
          [disabled]="fileBase64Path == '' || !hasInsertPermissions || uploadSelectedClientId == 0">
          Upload
        </button>

      </div>
    </div>
  </mat-dialog-actions>